import { Add } from '@mui/icons-material';
import { Box } from '@mui/material';
import qs from 'qs';
import React, { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DisableContext } from '../../../contexts/DisableContextProvider';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { EventItemQueryParams } from '../../../types/Event';
import ResponsiveButton from '../../../uikit/buttons/ResponsiveButton';
import TemplateModal from '../../events/TemplateModal/TemplateModal';
import EventsFilter, { ViewMode } from '../filters/EventsFilter';

interface Props {
  entityType: 'employees' | 'contacts' | 'account';
  viewMode: ViewMode;
  onViewModeChange: (newMode: ViewMode) => void;
}

const EventsTimelineHeader: React.FC<Props> = ({ entityType, viewMode, onViewModeChange }) => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const [showEventTemplateModal, setShowEventTemplateModal] = useState(false);
  const isAccount = entityType === 'account';

  const newWithTemplate = (templateUuid: string | null) => {
    const queryParams: EventItemQueryParams = {
      account: uuid,
    };
    if (templateUuid) {
      queryParams.template = templateUuid;
    }
    const queryString = qs.stringify(queryParams);
    navigate(`/${ROUTE_PATHS.EVENTS}/new?${queryString}`);
  };

  const { disabled } = useContext(DisableContext);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <EventsFilter viewMode={viewMode} onViewModeChange={onViewModeChange} />
      {isAccount && (
        <>
          <ResponsiveButton disabled={disabled} startIcon={<Add />} variant="outlined" onClick={() => setShowEventTemplateModal(true)}>
            Add
          </ResponsiveButton>
          <TemplateModal isOpen={showEventTemplateModal} onCancel={() => setShowEventTemplateModal(false)} onCreate={newWithTemplate} />
        </>
      )}
    </Box>
  );
};

export default EventsTimelineHeader;
